import { alpha, styled } from '@mui/material';
import Container from '@mui/material/Container';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';

import { Text } from '@knowz/knowz-ui';

export const FlexGrowContainer = styled(Container)(() => ({
  flex: 1,
}));

export const StyledCenteredContent = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: '100%',
}));

export const StyledGradientText = styled(Text)(({ theme }) => ({
  backgroundClip: 'text!important',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.3)
      : alpha(theme.palette.common.black, 0.15),
  background: theme.palette.createBrandGradients.primary({
    alpha1: alpha(theme.palette.common.black, 0.4),
    alpha2: alpha(theme.palette.common.white, 0.2),
  }),
}));

export const SharedStyledSlide = styled(Slider)(({ theme }) => ({
  cursor: 'default',
  padding: '0!important',
  '.MuiSlider-thumb': {
    display: 'none',
  },
  '& .MuiSlider-rail':
    theme.palette.mode === 'dark'
      ? {
          opacity: 0.3,
          backgroundColor: '#E9EAEB', // TODO: design system
        }
      : {
          opacity: 1,
          backgroundColor: 'rgba(0,0,0,0.20)',
        },
  '& .MuiSlider-track': {
    background: 'linear-gradient(to left,#36BFFA, #0040C1)', //TODO: design system
    border: 0,
  },
}));
